import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-roulette-icon',
  templateUrl: './tools-roulette.component.html'
})
export class ToolsRouletteComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
